'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var argsOrArray = function argsOrArray(args) {
  return args.length === 1 && Array.isArray(args[0]) ? args[0] : args;
};

var makePath = function makePath(strOrPath) {
  return typeof strOrPath === 'string' ? strOrPath.split('.').map(function (x) {
    return isNaN(x) ? x : Number(x);
  }) : strOrPath;
};
var immutableSplice = function immutableSplice(arr, start, deleteCount) {
  for (var _len = arguments.length, items = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    items[_key - 3] = arguments[_key];
  }

  return [].concat(_toConsumableArray(arr.slice(0, start)), items, _toConsumableArray(arr.slice(start + deleteCount)));
};

var clone = function clone(obj) {
  return Object.assign({}, obj);
};
var omit = function omit(key, obj) {
  var r = clone(obj);
  delete r[key];
  return r;
};

var symbols = {
  RENAME: Symbol('RENAME'),
  DELETE: Symbol('DELETE')
};

var ops = {
  delete: _defineProperty({}, symbols.DELETE, true),
  renameTo: function renameTo(key) {
    return _defineProperty({}, symbols.RENAME, key);
  }
};

var applyUpdateAt = function applyUpdateAt(path, fn, obj) {
  var parents = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

  if (path.length === 0) return typeof fn === 'function' ? fn.apply(undefined, [obj].concat(_toConsumableArray(parents))) : fn;else {
    var key = path[0];
    var replacement = applyUpdateAt(path.slice(1), fn, obj && obj[key], [obj].concat(_toConsumableArray(parents)));
    var isDelete = replacement && replacement[symbols.DELETE];
    var renameTo = replacement && replacement[symbols.RENAME];
    var isRename = Boolean(renameTo);

    if (obj && replacement === obj[key]) return obj;

    if (Array.isArray(obj)) {

      if (isNaN(key)) {
        throw new Error('Attempted to set a non-numeric key \'' + key + '\' in array ' + (parents.length && '' + parents[0]));
      } else if (isRename) {
        throw new Error("Attempted to rename an array key (${key} -> ${renameTo})");
      } else if (isDelete) {
        return immutableSplice(obj, key, 1);
      } else {
        return immutableSplice(obj, key, 1, replacement);
      }
    } else if (isRename) {

      if (obj && obj[key]) {
        return omit(key, Object.assign({}, obj, _defineProperty({}, renameTo, obj[key])));
      } else {
        // don't modify
        return obj;
      }
    } else if (isDelete) {
      return omit(key, obj);
    } else {
      return Object.assign({}, obj, _defineProperty({}, key, replacement));
    }
  }
};

var updateAt = function updateAt(path, fn) {
  var arrPath = Array.isArray(path) ? path : [path];
  return function (obj) {
    return applyUpdateAt(arrPath, fn, obj);
  };
};

var updateShallow = function updateShallow(shape) {
  return updates(Object.keys(shape).map(function (k) {
    return updateAt(k, shape[k]);
  }));
};
var updateList = function updateList(listOfFns) {
  // Pre-check for misuse
  listOfFns.forEach(function (f) {
    if (typeof f !== 'function') {
      var e = new Error('Received non-function in updates(...) call. (You provided a list of transform functions, but one of those transforms was not a function).');
      e.valueInError = f;
      throw e;
    }
  });
  return function (obj) {
    return listOfFns.reduce(function (acc, cur) {
      return cur(acc);
    }, obj);
  };
};

var updates = function updates() {
  for (var _len2 = arguments.length, fnsOrArrayOrObject = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fnsOrArrayOrObject[_key2] = arguments[_key2];
  }

  return Array.isArray(fnsOrArrayOrObject[0]) ? updateList(fnsOrArrayOrObject[0]) : _typeof(fnsOrArrayOrObject[0]) === 'object' ? updateShallow(fnsOrArrayOrObject[0]) : updateList(fnsOrArrayOrObject);
};

// THIS SHOULD REALLY BE USED SPARINGLY.
// Using updates({ some: value, other: value, netsted: updates({ a:1, b:2  }) }) seems preferable in _most_ scenarios
// Mostly because you need to remember to lift values if you intend them to be treated as values, not further nested updates!
/* Consider:
  const newUser = getUserFromSomewhere('123')
  const newDatabase = updateDeep({
    entities:{
      users:{
        ['123']:newUser // Watch out!
      }
    }
  })(database)
*/
// A casual eye would lead you to expect this replaces database.entities.users['123'] with newUser - but it does not:
// Since updateDeep is recursive, `newUser` describes the tree of deeper updates.
// So newUser would be _merged_ into whatever is already in database.entities.users['123']
// The alternative is to _lift_ newUser, such that the leaf level update becomes () => newUser, but this still requires the
// developer to be aware of this caveat.
var updateDeep = function updateDeep(patternOrValue) {
  var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if ((typeof patternOrValue === 'undefined' ? 'undefined' : _typeof(patternOrValue)) === 'object' && !Array.isArray(patternOrValue)) {
    return updates(Object.keys(patternOrValue).map(function (k) {
      return updateAt(k, updateDeep(patternOrValue[k]));
    }));
  } else {
    return updateAt([], patternOrValue);
  }
};

var map = function map(fn) {
  return function (arr) {
    if (!arr) {
      return arr;
    } else if (!Array.isArray(arr)) {
      var e = new Error('Attempted to map over non-array');
      e.valueInError = arr;
      throw e;
    } else {
      return arr.map(fn);
    }
  };
};

module.exports = {
  makePath: makePath,
  updateAt: updateAt,
  updates: updates,
  updateDeep: updateDeep,
  // Deprecated
  updateShape: updateDeep,
  map: map,
  ops: ops
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/fn-update/dist/index.js
// module id = 7
// module chunks = 34